// Components imports
import AppSearchBar from "./components/AppSearchBar";

// React instances
global.React = require("react");
global.ReactDOM = require("react-dom");
global.ReactDOMServer = require("react-dom/server");

// Components
global.AppSearchBar = AppSearchBar;